import { endOfDay } from 'date-fns/endOfDay';
import { startOfDay } from 'date-fns/startOfDay';
import { subDays } from 'date-fns/subDays';
import * as React from 'react';

type SetDateRangeCallback = (startDate: Date, endDate: Date) => void;

type SetDateRangeAction = React.Dispatch<React.SetStateAction<Date>>;

export type DateRangeProps = {
  dateRange: { fromDate: Date; toDate: Date };
  setDateRange: SetDateRangeCallback;
};

export const DEFAULT_DAYS_AGO = 7;

export const useStartDateState = (daysAgo = 0): [startDate: Date, setStartDate: SetDateRangeAction] => {
  const now = new Date();
  const date = startOfDay(subDays(now, daysAgo));

  return React.useState<Date>(date);
};

export const useEndDateState = (): [endDate: Date, setEndDate: SetDateRangeAction] => {
  const now = new Date();
  const date = endOfDay(now);

  return React.useState<Date>(date);
};

export const useSetDateRange: (
  setStartDate: SetDateRangeAction,
  setEndDate: SetDateRangeAction,
) => (startDate: Date, endDate: Date) => void = (setStartDate: SetDateRangeAction, setEndDate: SetDateRangeAction) =>
  React.useCallback(
    (startDate: Date, endDate: Date) => {
      setStartDate(startDate);
      setEndDate(endDate);
    },
    [setEndDate, setStartDate],
  );
